module.exports = __webpack_public_path__ + "static/img/bg.82806c6c.jpg";